import React from 'react';
import { t } from '@lingui/macro';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dialog } from '@economic/taco';
import { useCurrentAgreement, useCurrentLocale } from '@economic/react-app';
import TransactionsTable from '~/app/shared/components/TransactionsTable';
import useDimensionsAccessLevel from '~/app/shared/dimensions/hooks/useDimensionsAccessLevel';
import { DimensionsAccess } from '~/app/shared/dimensions/types';

const ShowTransactionsView = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { voucherId } = location.state;

    const { currencyCode: currency } = useCurrentLocale();
    const agreement = useCurrentAgreement();
    const hasAccessProjectUser = agreement.modules.project;
    const hasDimension = useDimensionsAccessLevel(DimensionsAccess.HasDimension);

    return (
        <Dialog
            open={location.hash === '#show-transactions'}
            onClose={() => navigate(location.pathname)}
            size="lg"
            closeOnEscape
            draggable>
            <Dialog.Title>{t`Show transactions`}</Dialog.Title>
            <Dialog.Content aria-label={t`Show transactions`}>
                <TransactionsTable
                    entryId={Number(voucherId)}
                    currency={currency}
                    hasDimension={hasDimension}
                    hasAccessProjectUser={hasAccessProjectUser}
                    showButtons
                />
            </Dialog.Content>
        </Dialog>
    );
};

export default ShowTransactionsView;
